/**
 * @param {object} props
 * @param {string} props.primaryColor
 * @param {string} props.secondaryColor
 * @param {number | string} props.viewBoxX
 * @param {number | string} props.viewBoxY
 * @param {boolean} props.hideChevrons
 */
function ArrowLeftSvg({ primaryColor, secondaryColor, viewBoxX = 0, viewBoxY = 0, hideChevrons }) {
    return (
        <svg viewBox={`${viewBoxX} ${viewBoxY} 804 649`} fill="none" xmlns="http://www.w3.org/2000/svg">
            {!hideChevrons && (
                <>
                    <mask
                        id="mask0_2056_10094"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="554"
                        height="649"
                    >
                        <rect
                            x="554"
                            y="649"
                            width="554"
                            height="649"
                            transform="rotate(-180 554 649)"
                            fill="url(#paint0_linear_2056_10094)"
                        />
                    </mask>
                    <g mask="url(#mask0_2056_10094)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M571 648.449C575.125 648.282 579.512 647.913 580.75 647.629L583 647.113V614.623V582.134L580.25 578.894C577.675 575.86 440.534 437.972 394.022 391.651C381.651 379.332 371.166 367.964 368.655 364.151C360.206 351.316 356 337.499 356 322.572C356 307.011 360.62 292.877 369.866 280.151C373.333 275.379 411.785 236.099 475.588 172.151C530.738 116.876 577.467 69.9006 579.431 67.7606L583 63.8705V32.5716V1.27356L578.75 0.653564C576.412 0.312564 519.6 -0.0524097 452.5 -0.15741C320.805 -0.36441 325.915 -0.540419 311.011 4.72058C305.197 6.77358 292.367 12.9466 290.753 14.4686C290.064 15.1186 286.35 18.2116 282.5 21.3416C275.907 26.7006 197.517 105.005 77.467 226.151C27.35 276.725 24.25 280.061 20.797 287.151C13.567 301.994 12.636 306.016 12.586 322.651C12.549 334.667 12.908 338.745 14.386 343.151C16.868 350.547 23.648 364.296 26.817 368.358C29.707 372.062 281.418 623.949 287.223 628.946C289.271 630.709 291.138 632.151 291.373 632.151C291.607 632.151 293.982 633.619 296.65 635.413C303.265 639.862 316.251 644.845 327.313 647.18C336.126 649.041 341.122 649.112 450 648.937C512.425 648.836 566.875 648.617 571 648.449Z"
                            fill="url(#paint1_linear_2056_10094)"
                        />
                    </g>
                    <mask
                        id="mask1_2056_10094"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="231"
                        y="0"
                        width="573"
                        height="649"
                    >
                        <rect
                            x="804"
                            y="649"
                            width="573"
                            height="649"
                            transform="rotate(-180 804 649)"
                            fill="url(#paint2_linear_2056_10094)"
                        />
                    </mask>
                    <g mask="url(#mask1_2056_10094)">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M792 648.449C796.125 648.282 800.512 647.913 801.75 647.629L804 647.113V614.623V582.134L801.25 578.894C798.675 575.86 661.534 437.972 615.022 391.651C602.651 379.332 592.166 367.964 589.655 364.151C581.206 351.316 577 337.499 577 322.572C577 307.011 581.62 292.877 590.866 280.151C594.333 275.379 632.785 236.099 696.588 172.151C751.738 116.876 798.467 69.9006 800.431 67.7606L804 63.8705V32.5716V1.27356L799.75 0.653564C797.412 0.312564 740.6 -0.0524097 673.5 -0.15741C541.805 -0.36441 546.915 -0.540419 532.011 4.72058C526.197 6.77358 513.367 12.9466 511.753 14.4686C511.064 15.1186 507.35 18.2116 503.5 21.3416C496.907 26.7006 418.517 105.005 298.467 226.151C248.35 276.725 245.25 280.061 241.797 287.151C234.567 301.994 233.636 306.016 233.586 322.651C233.549 334.667 233.908 338.745 235.386 343.151C237.868 350.547 244.648 364.296 247.817 368.358C250.707 372.062 502.418 623.949 508.223 628.946C510.271 630.709 512.138 632.151 512.373 632.151C512.607 632.151 514.982 633.619 517.65 635.413C524.265 639.862 537.251 644.845 548.313 647.18C557.126 649.041 562.122 649.112 671 648.937C733.425 648.836 787.875 648.617 792 648.449Z"
                            fill="url(#paint3_linear_2056_10094)"
                        />
                    </g>
                </>
            )}
            <defs>
                <linearGradient
                    id="paint0_linear_2056_10094"
                    x1="1108"
                    y1="925.444"
                    x2="554"
                    y2="925.444"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.04" />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_2056_10094"
                    x1="13"
                    y1="337.5"
                    x2="583"
                    y2="337.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={secondaryColor} />
                    <stop offset="0.84" stopColor={primaryColor} />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_2056_10094"
                    x1="1377"
                    y1="925.444"
                    x2="804"
                    y2="925.444"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.04" />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_2056_10094"
                    x1="234"
                    y1="337.5"
                    x2="804"
                    y2="337.5"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor={secondaryColor} />
                    <stop offset="0.84" stopColor={primaryColor} />
                </linearGradient>
            </defs>
        </svg>
    );
}

export default ArrowLeftSvg;
